import { RailCard } from './rail-card'

function SummaryMetric({
    value,
    label,
    tone,
}: {
    value: number
    label: string
    tone: 'warning' | 'success' | 'muted'
}) {
    const toneClass = {
        warning: 'text-warning',
        success: 'text-success',
        muted: 'text-muted-foreground',
    }[tone]

    return (
        <div className='border-border rounded-sm border p-3 text-center'>
            <div className={`${toneClass} text-2xl font-bold`}>{value}</div>
            <div className='text-muted-foreground text-xs font-bold'>
                {label}
            </div>
        </div>
    )
}

/** 영향 분석 결과의 재점검/유지/영향 없음 건수를 요약한다. */
export function RecheckSummaryCard({
    recheckCount,
    keepCount,
    unaffectedCount,
}: {
    recheckCount: number
    keepCount: number
    unaffectedCount: number
}) {
    return (
        <RailCard title='재점검 요약'>
            <div className='grid grid-cols-3 gap-2'>
                <SummaryMetric
                    value={recheckCount}
                    label='재점검 필요'
                    tone='warning'
                />
                <SummaryMetric value={keepCount} label='유지' tone='success' />
                <SummaryMetric
                    value={unaffectedCount}
                    label='영향 없음'
                    tone='muted'
                />
            </div>
        </RailCard>
    )
}
